export class LoadTransactionVolumeMetrics {
	static readonly type: string = '[Transactions] LoadTransactionVolumeMetrics';
	constructor() {}
}

export class ClearTransactionsState {
	static readonly type: string = '[Transactions] ClearTransactionsState';
}
